import Home, { getStaticProps as getStaticHomeProps } from '../components/pages/Home';

export const getStaticProps = getStaticHomeProps;

export default Home;
